import 'css-chunksrc/client/pages/zonesPage/zonesPage/zone/styles.scss';export default {
  "zone": "_zone_jgpi0_1",
  "zoneAvatar": "_zoneAvatar_jgpi0_10",
  "header": "_header_jgpi0_17",
  "projects": "_projects_jgpi0_32",
  "projectsNumberBox": "_projectsNumberBox_jgpi0_39",
  "folderIcon": "_folderIcon_jgpi0_52",
  "projectNbr": "_projectNbr_jgpi0_58",
  "name": "_name_jgpi0_64",
  "icon": "_icon_jgpi0_69",
  "weather": "_weather_jgpi0_78",
  "contextualMenu": "_contextualMenu_jgpi0_84",
  "button": "_button_jgpi0_96",
  "displayContextualMenu": "_displayContextualMenu_jgpi0_111",
  "empty": "_empty_jgpi0_115"
};